/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CentralSystemResponse
 */
export interface CentralSystemResponse {
    /**
     *
     * @type {string}
     * @memberof CentralSystemResponse
     */
    centralSystemId?: string;
    /**
     *
     * @type {string}
     * @memberof CentralSystemResponse
     */
    fullName?: string;
    /**
     *
     * @type {number}
     * @memberof CentralSystemResponse
     */
    rowSequence?: number;
}

/**
 * Check if a given object implements the CentralSystemResponse interface.
 */
export function instanceOfCentralSystemResponse(
    value: object,
): value is CentralSystemResponse {
    return true;
}

export function CentralSystemResponseFromJSON(
    json: any,
): CentralSystemResponse {
    return CentralSystemResponseFromJSONTyped(json, false);
}

export function CentralSystemResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CentralSystemResponse {
    if (json == null) {
        return json;
    }
    return {
        centralSystemId:
            json["centralSystemId"] == null
                ? undefined
                : json["centralSystemId"],
        fullName: json["fullName"] == null ? undefined : json["fullName"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
    };
}

export function CentralSystemResponseToJSON(
    value?: CentralSystemResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        centralSystemId: value["centralSystemId"],
        fullName: value["fullName"],
        rowSequence: value["rowSequence"],
    };
}
